import React from 'react';
import {useSelector} from "react-redux";
import moment from 'moment';

import {DATE_FORMAT} from 'constants/index.js';

export default function () {
    const school_subscription = useSelector(state => state.me_school_subscription);

    return (
        <div className='profile-membership-card'>
            <div className="">
                <div className="flex-row">
                    <div className={'plan-logo school'}>
                        <i className="fas fa-address-card"></i>
                    </div>
                </div>
                <div className='mt-2'>Membership</div>
                <h4 className="header-new mt-0">School Plan</h4>
            </div>

            <div className="card-rows">
                <div className="flex-row">
                    <div className='card-label'>Valid until:</div>
                    <div>{moment(school_subscription.ends_at).format(DATE_FORMAT)}</div>
                </div>
            </div>
        </div>
    );
}
